import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getTargetGroups } from './index';

export const createTargetGroupsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getTargetGroups: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getTargetGroups(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getTargetGroups', isInFlight);
    },
  ),
});
